import React, { PropsWithChildren } from 'react';
import styles from './Info.module.scss';
import { Skeleton, Typography } from '@mui/material';

interface InfoProps {
  label?: string;
  value?: string | number;
  loading?: boolean;
}

export function Info(props: PropsWithChildren<InfoProps>) {
  return (
    <div className={styles.container}>
      <Typography variant="overline">{props.label}</Typography>
      {props.loading ? (
        <Skeleton animation="wave" variant="rounded" width={100} height={40} />
      ) : null}
      {props.value && !props.loading ? <Typography variant="h1">{props.value}</Typography> : null}
      {props.children}
    </div>
  );
}
